
export default {
  categoria: [],
  codArrecadacao: [],
  instituicao: [],

  loadingParcelamento: false
}
